import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd553c8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-center md:justify-between flex-col sm:flex-row items-center mt-8" }
const _hoisted_2 = { class: "intro-y text-lg font-medium m-auto md:mr-auto md:ml-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inline-block col-span-4 py-3 px-1 bg-red-700 text-center rounded rounded-r-none" }, " X ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inline-block col-span-8 p-3 bg-red-600 text-center rounded rounded-l-none" }, "Selesai", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "intro-y grid grid-cols-12 gap-3 sm:gap-2 mt-5" }
const _hoisted_7 = { class: "intro-y col-span-12 box px-3 sm:px-5 pb-5" }
const _hoisted_8 = { class: "flex flex-row items-center justify-between py-5 border-b border-gray-200 dark:border-dark-5" }
const _hoisted_9 = { class: "grid grid-cols-12 w-24 sm:w-32 button p-0 items-center justify-center text-white cursor-pointer" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inline-block col-span-5 sm:col-span-4 py-3 px-1 bg-blue-800 text-center rounded rounded-r-none" }, "NO", -1))
const _hoisted_11 = { class: "inline-block col-span-7 sm:col-span-8 p-3 bg-blue-600 text-center rounded rounded-l-none" }
const _hoisted_12 = { class: "grid grid-cols-12 w-36 sm:w-40 button p-0 items-center justify-center text-white" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inline-block col-span-5 py-3 px-1 bg-yellow-400 text-center rounded rounded-r-none" }, "Waktu", -1))
const _hoisted_14 = { class: "inline-block col-span-7 p-3 bg-yellow-300 text-center rounded rounded-l-none" }
const _hoisted_15 = { class: "pt-5 pb-2" }
const _hoisted_16 = { class: "text-base font-medium mt-1 mb-1 uppercase" }
const _hoisted_17 = ["src"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["opt", "onClick"]
const _hoisted_20 = { class: "inline-block px-2 py-2 w-8 rounded rounded-r-none text-center border border-gray-500 dark:border-gray-600" }
const _hoisted_21 = { class: "inline-block pl-2 sm:pl-3 pr-2 py-2 w-full rounded rounded-l-none text-left border border-gray-500 dark:border-gray-600" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "flex flex-row items-center justify-center justify-items-center pt-5 border-t border-gray-200 dark:border-dark-5" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:block" }, "Back", -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Ragu-ragu ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:block" }, "Next", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:block" }, "Done", -1))
const _hoisted_30 = { class: "intro-y col-span-12 box p-2" }
const _hoisted_31 = { class: "intro-y col-span-12 flex flex-row justify-between border-b border-gray-200 dark:border-dark-5 pt-2 pb-3" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "intro-y text-lg font-medium w-full" }, "Navigasi Soal", -1))
const _hoisted_33 = { class: "w-auto overflow-auto scrollbar-nav-soal mb-3" }
const _hoisted_34 = {
  id: "nsRn",
  class: "flex flex-row"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "flex justify-between flex-col sm:flex-row items-center mt-8 md:mt-0" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inline-block col-span-4 py-3 px-1 bg-red-700 text-center rounded rounded-r-none" }, " X ", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inline-block col-span-8 p-3 bg-red-600 text-center rounded rounded-l-none" }, "Selesai", -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = {
  id: "done-tryout-exam",
  class: "modal"
}
const _hoisted_41 = { class: "modal__content" }
const _hoisted_42 = { class: "p-5 text-center" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-3xl mt-5" }, "Are you sure?", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 mt-2" }, " Apakah Anda ingin mengakhiri simulasi ujian ini? Jika \"Ya\" maka Anda sudah dinyatakan selesai mengikuti simulasi ujian, dan Anda tidak bisa memperbaiki lembar kerja Anda. Jika \"Tidak\" maka Anda akan kembali ke lembar kerja dan silahkan untuk melanjutkan menjawab atau memperbaiki jawaban Anda. ", -1))
const _hoisted_45 = { class: "px-5 pb-8 text-center" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-dismiss": "modal",
  class: "button w-24 border text-gray-700 dark:border-dark-5 dark:text-gray-300 mr-1"
}, " Tidak ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon")!
  const _component_HelpCircleIcon = _resolveComponent("HelpCircleIcon")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.dataExam.title), 1),
      _createElementVNode("div", {
        class: "md:grid grid-cols-12 hidden w-36 items-center button p-0 justify-center text-white cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gpf.showModal('#done-tryout-exam')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.cs.nomor), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.time.hours) + ":" + _toDisplayString(_ctx.time.minutes) + ":" + _toDisplayString(_ctx.time.seconds), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.cs.kategori), 1),
          (_ctx.cs.questionImg)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.cs.questionImg,
                class: "m-2",
                alt: "Image Soal"
              }, null, 8, _hoisted_17))
            : _createCommentVNode("", true),
          _createElementVNode("p", {
            class: "border-b border-gray-500 dark:border-gray-600 p-2 mb-2 bg-gray-200 dark:bg-dark-1 text-base",
            innerHTML: _ctx.cs.question
          }, null, 8, _hoisted_18),
          _createElementVNode("ol", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cs.option, (opt, idx) => {
              return (_openBlock(), _createElementBlock("li", {
                key: idx,
                opt: 'chs-' + _ctx.cs.nomor + '-' + idx,
                class: _normalizeClass([
                'flex flex-row justify-items-center my-3 md:my2 cursor-pointer button p-0 list-chs',
                _ctx.cs.answer && _ctx.cs.answerIdx === idx ? 'active' : '',
              ]),
                onClick: ($event: any) => (_ctx.chooseOpt(_ctx.cs, _ctx.cs.nomor, idx))
              }, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(opt.option), 1),
                _createElementVNode("span", _hoisted_21, [
                  (opt.image)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: opt.image,
                        alt: "Image Opsi Soal"
                      }, null, 8, _hoisted_22))
                    : _createCommentVNode("", true),
                  (opt.image)
                    ? (_openBlock(), _createElementBlock("br", _hoisted_23))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    innerHTML: opt.text
                  }, null, 8, _hoisted_24)
                ])
              ], 10, _hoisted_19))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          (_ctx.cis !== 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button w-auto h-11 mr-2 md:mr-5 pl-1 md:pr-5 flex items-center justify-center bg-theme-1 text-white",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeSoalCis('back')))
              }, [
                _createVNode(_component_ChevronLeftIcon, { class: "w-6 h-6 ml-1 mr-0 sm:mr-2 font-bold" }),
                _hoisted_26
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "button w-32 h-11 flex items-center justify-center bg-theme-12 text-white",
            onClick: _cache[2] || (_cache[2] = ($event: any) => {
              _ctx.allSoal[_ctx.cis].ragu = !_ctx.allSoal[_ctx.cis].ragu;
              _ctx.setRagu();
            })
          }, [
            _createVNode(_component_HelpCircleIcon, { class: "w-6 h-6 mr-2 font-bold" }),
            _hoisted_27
          ]),
          (_ctx.cis !== _ctx.allSoal.length - 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "button w-auto h-11 ml-2 md:ml-5 pl-3 md:pl-5 md:pr-1 pr-2 sm:pr-1 flex items-center justify-center bg-theme-1 text-white flex-row-reverse",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeSoalCis('next')))
              }, [
                _createVNode(_component_ChevronRightIcon, { class: "w-6 h-6 ml-0 sm:ml-2 font-bold mr-auto" }),
                _hoisted_28
              ]))
            : (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "button w-auto h-11 ml-2 md:ml-5 pl-2 md:pl-4 md:pr-2 pr-2 flex items-center justify-center bg-green-500 dark:bg-green-700 text-white flex-row-reverse",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.gpf.showModal('#done-tryout-exam')))
              }, [
                _createVNode(_component_CheckIcon, { class: "w-6 h-6 ml-0 sm:ml-2 font-bold mr-auto" }),
                _hoisted_29
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("a", {
            id: "cvRn",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.rn())),
            href: "javascript:;",
            class: "font-bold cursor-pointer"
          }, [
            _createVNode(_component_ChevronDownIcon, { class: "w-6 h-6 mr-0" })
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("ol", _hoisted_34, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allSoal, (soal, idx) => {
              return (_openBlock(), _createElementBlock("li", {
                key: idx,
                class: _normalizeClass([
                'my-2 px-2 list-ns',
                idx === _ctx.cis ? 'active' : '',
                soal.ragu ? 'ragu' : '',
                soal.answer && !soal.ragu ? 'yakin' : '',
              ])
              }, [
                _createElementVNode("button", {
                  class: "intro-y w-16 h-10 rounded button bg-gray-200 dark:bg-dark-1 text-gray-600 px-1",
                  onClick: ($event: any) => (_ctx.changeSoal(soal, idx))
                }, _toDisplayString(soal.nomor) + " - " + _toDisplayString(soal.answer ? soal.answer : ""), 9, _hoisted_35)
              ], 2))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", {
        class: "grid grid-cols-12 md:hidden w-36 items-center button p-0 justify-center text-white cursor-pointer",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.gpf.showModal('#done-tryout-exam')))
      }, _hoisted_39)
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_component_HelpCircleIcon, { class: "w-16 h-16 text-theme-6 mx-auto mt-3" }),
          _hoisted_43,
          _hoisted_44
        ]),
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createElementVNode("button", {
            type: "button",
            class: "button w-24 bg-theme-6 text-white",
            "data-dismiss": "modal",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.tryoutHasil()))
          }, " Ya ")
        ])
      ])
    ])
  ]))
}